import React, { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';
import { saveGeneralInformation, wizardStore } from '../../../../stores/wizard';
import { GeneralInformation } from '../../../../types/wizard';

const ountileCls = 'outline-none hover:outline-none focus:outline-none';

const GeneralInfo = () => {
  const wizSnap = useSnapshot(wizardStore);
  const initialFormData: GeneralInformation = {
    requestor: wizSnap.designRequest.generalInformation.requestor || '',
    poNumber: wizSnap.designRequest.generalInformation.poNumber || '',
    description: wizSnap.designRequest.generalInformation.description || '',
  };
  const [formData, setFormData] = useState<GeneralInformation>(initialFormData);
  const [hasAttemptedSave, setHasAttemptedSave] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setHasAttemptedSave(true);
  };

  useEffect(() => {
    if (!formData.requestor || !formData.description) {
      return;
    }

    const dataToSave: GeneralInformation = {
      requestor: formData.requestor,
      poNumber: formData.poNumber,
      description: formData.description,
    };

    saveGeneralInformation(dataToSave);
  }, [formData]);

  return (
    <div className="w-full">
      {/* Requestor */}
      <div className="mb-4">
        <label className="block uppercase font-bold mb-2.5">
          Requestor <span className="text-[#a61613]">*</span>
        </label>
        <input
          type="text"
          name="requestor"
          value={formData.requestor}
          onChange={handleInputChange}
          className={`w-6/12 border border-solid p-2.5 cursor-pointer relative rounded bg-white ${formData.requestor === '' && hasAttemptedSave ? 'border-[#a61613]' : 'border-[#ccc]'
            } ${ountileCls}`}
        />
        {(formData.requestor === '' && hasAttemptedSave) && (
          <p className="text-[#a61613] text-sm leading-4 mt-2">Requestor is required</p>
        )}
      </div>

      {/* P.O. Number */}
      <div className="mb-4">
        <label className="block uppercase font-bold mb-2.5">
          P.O. Number
        </label>
        <input
          type="text"
          name="poNumber"
          value={formData.poNumber}
          onChange={handleInputChange}
          className={`w-6/12 border border-solid border-[#ccc] p-2.5 cursor-pointer relative rounded bg-white ${ountileCls}`}
        />
      </div>

      {/* Design Description */}
      <div className="mb-4">
        <label className="block uppercase font-bold mb-2.5">
          Design Description <span className="text-red-500">*</span>
        </label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          className={`w-full block bg-white bg-clip-padding px-3 py-1.5 rounded-[3px] border border-solid ${formData.description === '' && hasAttemptedSave ? 'border-[#a61613]' : 'border-[#ccc]'
            } ${ountileCls}`}
          rows={3}
        />
        {(formData.description === '' && hasAttemptedSave) && (
          <p className="text-[#a61613] text-sm leading-4 mt-2">Description is required</p>
        )}
      </div>
    </div>
  );
};

export default GeneralInfo;